<script>
import { computed, defineComponent, h, onMounted, ref } from "vue";
import store from "@/store";
import turnstile from "./turnstile-wrapper";

export default defineComponent({
  name: "CFTurnstile",
  props: {
    sitekey: {
      type: String,
      required: true,
    },
    badge: {
      type: String,
    },
    type: {
      type: String,
    },
    size: {
      type: String,
    },
    tabindex: {
      type: Number,
    },
    loadTurnstileScript: {
      type: Boolean,
      default: true,
    },
    turnstileScriptId: {
      type: String,
      default: "__TURNSTILE_SCRIPT",
    },
    turnstileHost: {
      type: String,
      default: "www.google.com",
    },
    language: {
      type: String,
      default: "",
    },
  },
  emits: ["render", "verify", "expired", "error"],

  setup(props, { slots, emit }) {
    const root = ref(null);
    const widgetId = ref(null);
    const theme = computed(() => store.getters["theme/get"]?.stylesheet);
    const emitVerify = (response) => emit("verify", response);
    const emitExpired = () => emit("expired");
    const emitError = () => emit("error");

    onMounted(() => {
      turnstile.checkTurnstileLoad();

      if (props.loadTurnstileScript) {
        if (!document.getElementById(props.turnstileScriptId)) {
          const script = document.createElement("script");
          script.id = props.turnstileScriptId;
          script.src =
            "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback&render=explicit";
          script.async = true;
          script.defer = true;

          document.head.appendChild(script);
        }
      }

      const opts = {
        ...props,
        callback: emitVerify,
        "expired-callback": emitExpired,
        "error-callback": emitError,
        theme: theme.value === "dark" ? "dark" : "light",
      };
      const $root = root.value;
      const container = slots.default ? $root.children[0] : $root;
      turnstile.render(container, opts, async (id) => {
        widgetId.value = id;

        emit("render", id);
      });
    });

    return {
      root,
      widgetId,
      reset() {
        turnstile.reset(widgetId.value);
      },
      execute() {
        turnstile.execute(widgetId.value);
      },
    };
  },
  render() {
    const defaultSlot = this.$slots.default;
    let defaultContent;
    if (typeof defaultSlot === "function") {
      defaultContent = defaultSlot();
    } else {
      defaultContent = defaultSlot;
    }
    return h("div", { ref: "root" }, defaultContent);
  },
});
</script>
